var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObjkt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_11_2",
    "data-name": "Component 11 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.198,
    height: 55.198,
    viewBox: "0 0 55.198 55.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 55.198,
    height: 55.198,
    rx: 26.753,
    fill: "#3c3c3c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(5.513 20.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1767.453-118.571c-.364,1.5-1.523.666-2.456.969V-131.06h2.765v4.585a10.452,10.452,0,0,1,2.316-.656,3.179,3.179,0,0,1,3.44,2.678,10.979,10.979,0,0,1-.06,4.2C1772.872-117.771,1769.846-116.6,1767.453-118.571Zm3.653-3.857a4.184,4.184,0,0,0-.4-1.591,2.353,2.353,0,0,0-1.553-1.015c-.413,0-1.043.729-1.184,1.242a7.551,7.551,0,0,0-.1,2.51c.065.857.407,1.629,1.448,1.624s1.455-.745,1.65-1.642C1771.033-121.615,1771.046-121.941,1771.105-122.428Z",
    transform: "translate(-1755.477 131.08)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M1788.79-131.083h2.791v6.811c1.773-1.578,2.986-3.859,5.689-2.467l-3.483,3.145,4.05,5.684c-2.041.638-2.826.389-3.974-1.225L1792-121.752c-.792,1.381-.163,2.725-.545,4h-2.67Z",
    transform: "translate(-1761.218 131.083)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M1761.769-122.416c-.032,2.305-1.987,3.929-4.706,3.91-2.69-.019-4.625-1.714-4.593-4.022.033-2.213,2.2-4.041,4.726-3.984C1759.8-126.453,1761.8-124.659,1761.769-122.416Zm-2.64,0a6.828,6.828,0,0,0-.462-1.367,1.8,1.8,0,0,0-2.955-.18,2.693,2.693,0,0,0,.072,3.015,1.8,1.8,0,0,0,2.684-.022A6.653,6.653,0,0,0,1759.13-122.413Z",
    transform: "translate(-1752.471 130.424)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M1776.448-114.948l1.47-1.963a5.816,5.816,0,0,0,1.47,1.1.992.992,0,0,0,1.442-.973c.023-.407.055-.814.057-1.22.006-1.988,0-3.976,0-6.074h-3.107v-2.106h5.9c0,3.225.091,6.472-.043,9.71a3.147,3.147,0,0,1-2.4,2.806A4.509,4.509,0,0,1,1776.448-114.948Z",
    transform: "translate(-1758.147 128.811)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M1802.722-126.821l.194-2.145,2.844-.409-.2,2.607h2.783v2.189h-2.878c0,1.341-.085,2.62.027,3.881.083.928.762,1.31,1.686,1.055.455-.125.888-.331,1.329-.5.785,1.755.694,1.975-1.018,2.557-2.812.954-4.709-.283-4.875-3.228-.068-1.208-.011-2.422-.011-3.687l-1.782-.141v-2.029Z",
    transform: "translate(-1764.016 130.837)",
    fill: "#f7f7f7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjkt);
export default __webpack_public_path__ + "static/media/objkt.2742a6f1.svg";
export { ForwardRef as ReactComponent };